import { Box, Grid, GridProps, InternalStandardProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppTypography } from "JS/React/Components/AppTypography";
import { DashboradLogs } from "./GiftDashboardListing";
import { DashboardListItemIcon } from "./Components/DashboardListItemIcon";
import { formatGiftDashboardDateTime } from "./dateFormat";
import { AppDivider } from "JS/React/Components/AppDivider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { secondsToPlayerDuration } from "JS/Helpers";

const StyledRoot = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(1.5, 1),
}));

const StyledCenterItem = styled(Grid)({
    marginLeft: "-10px",
});

const StyledTitle = styled(AppTypography)(({ theme }) => ({
    fontSize: "18px",
    marginBottom: "5px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: theme.palette.grey[600],
}));

const StyledSkuId = styled(AppTypography)(({ theme }) => ({
    fontSize: "14px",
    color: theme.palette.grey[600],
}));

const StyledPrimaryColorIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}));

export const GiftDashboardListItem = (props: GiftDashboadListItemProps) => {
    const { className, giftActivity: content, ...rest } = props;

    return (
        <>
            <StyledRoot container className={className} {...rest}>
                <Grid
                    item
                    xs={2}
                    display="flex"
                    justifyContent="center"
                    alignItems={"center"}
                >
                    <DashboardListItemIcon contentType={content.contentType} />
                </Grid>
                <StyledCenterItem item xs={10}>
                    <Box display={"flex"} justifyContent={"space-between"}>
                        <StyledTitle>
                            {formatGiftDashboardDateTime(content?.createdAt)}
                        </StyledTitle>
                    </Box>
                    <Box display={"flex"} justifyContent={"start"}>
                        {content?.receiverFirstName &&
                            content?.receiverLastName && (
                                <>
                                    <StyledPrimaryColorIcon
                                        icon={["fas", "user"]}
                                    />
                                    &nbsp;
                                    <StyledSkuId>
                                        {content.receiverFirstName}{" "}
                                        {content.receiverLastName} |{" "}
                                        {content.contentType} |{" "}
                                        {content.contentTitle} |{" "}
                                        {content.activity.actionDetails
                                            ?.stepName
                                            ? `Step | ${content.activity.actionDetails?.stepName} | `
                                            : ""}
                                        {content.activity.action}{" "}
                                        {!!content?.activity?.actionDetails
                                            ?.duration &&
                                            `| Duration:
                                ${secondsToPlayerDuration(
                                    content?.activity?.actionDetails?.duration,
                                )}`}
                                    </StyledSkuId>
                                </>
                            )}
                    </Box>
                </StyledCenterItem>
            </StyledRoot>
            <AppDivider />
        </>
    );
};

export interface GiftDashboadListItemProps
    extends InternalStandardProps<GridProps> {
    giftActivity: DashboradLogs;
}
